import React, { ReactElement } from 'react';
import { Icon } from '@zencity/common-ui';
import { DELIMITER, NO_CHANGE, NO_COMPARISON } from 'screens/WidgetGenerator/constants';
import { ConcernItem } from 'screens/WidgetGenerator/utils/answerClassificationBreakdown';
import styles from './ClassificationTopConcernsHOC.module.scss';

const SIGN_ICON_DIMENSION = 20;

interface Props {
  concernItem: ConcernItem;
  displayTrend: boolean;
}

export const TopConcernsChartItemTrend = (props: Props): ReactElement | null => {
  const { concernItem, displayTrend } = props;

  if (!displayTrend) {
    return null;
  }

  const percentageTrend = concernItem.previousPercentage
    ? Math.round(concernItem.percentage - concernItem.previousPercentage)
    : 0;

  // When previous percentage is missing but still need to display the trend,
  // use an empty string, just to keep the correct spacing.
  const percentageTrendStr = concernItem.previousPercentage ? `${Math.abs(percentageTrend)}%` : NO_COMPARISON;
  const noChangeSign = concernItem.previousPercentage ? NO_CHANGE : '';

  let sign;
  if (percentageTrend > 0) {
    sign = <Icon name="arrow-up.svg" width={SIGN_ICON_DIMENSION} height={SIGN_ICON_DIMENSION} />;
  } else if (percentageTrend < 0) {
    sign = <Icon name="arrow-down.svg" width={SIGN_ICON_DIMENSION} height={SIGN_ICON_DIMENSION} />;
  }

  return (
    <div className={styles.chartItemPercentageTrend}>
      <div className={styles.delimiter}>{DELIMITER}</div>
      <div>{sign || noChangeSign}</div>
      <div className={styles.percentageTrend}>{percentageTrendStr}</div>
    </div>
  );
};
